// extracted by mini-css-extract-plugin
export default {"login":"Login_login__dH0gZ","ChatBtn":"Login_ChatBtn__Thf6W"};